import { render, staticRenderFns } from "./NotificationLis.vue?vue&type=template&id=703a1973&"
import script from "./NotificationLis.vue?vue&type=script&lang=js&"
export * from "./NotificationLis.vue?vue&type=script&lang=js&"
import style0 from "./NotificationLis.vue?vue&type=style&index=0&id=703a1973&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports